import React from 'react';

import { Col, Row } from 'reactstrap';

import TextBox from '@components/TextBox/TextBox';
import ListBox from '@components/ListBox/ListBox';

const desktop = props => {
  const activeBox = props.boxs.find(x => x.id === props.active).content;

  return (
    <Row className={'justify-content-center w-100 mx-auto'}>
      <Col md={10}>
        <Row>
          <Col md={6}>
            <Row className={props.heightSm ? 'mb-1' : 'mb-5'}>
              <Col md={9}>
                <TextBox
                  header={'Compare Aircraft'}
                  style={{ paddingBottom: '0.1rem' }}
                  isHeader={true}
                />
              </Col>
            </Row>
            <Row>
              {props.boxs.map(box => (
                <ListBox
                  colStyles={
                    props.heightSm
                      ? { marginTop: '0.5rem', marginBottom: '0.5rem' }
                      : {}
                  }
                  activeBox={props.active}
                  id={box.id}
                  key={box.id}
                  title={box.title}
                  click={() => props.click(box.id)}
                />
              ))}
            </Row>
          </Col>
          <Col
            md={{ offset: 1, size: 5 }}
            className={'d-flex flex-column justify-content-end pb-3'}
          >
            {activeBox}
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default desktop;



// WEBPACK FOOTER //
// ./src/components/CompareAircraft/Desktop/Desktop.js